export const INITIALIZE_ACTION = 'app/NifUploader/INITIALIZE_ACTION';
export const UPLOAD_FILE_ACTION = 'app/NifUploader/UPLOAD_FILE_ACTION';
export const DELETE_FILE_ACTION = 'app/NifUploader/DELETE_FILE_ACTION';
export const UPDATE_EXPIRATION_DATE = 'app/NifUploader/UPDATE_EXPIRATION_DATE';
export const UPDATE_ERROR_EXPIRATION_DATE = 'app/NifUploader/UPDATE_ERROR_EXPIRATION_DATE';
